import { useTranslation } from 'react-i18next';
import { MapPin } from 'lucide-react';

export function ShippingCard({
  shippingLocationName,
  addressLine1,
  addressLine2,
  region,
  city,
  zipCode,
}: {
  shippingLocationName: string;
  addressLine1: string;
  addressLine2?: string | undefined | null;
  region: string;
  city: string;
  zipCode: string;
}) {
  const { t } = useTranslation('order');

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm">
      <div className="flex items-center gap-2 mb-4">
        <MapPin size={20} className="text-prim-500" />
        <h2 className="text-neutral-900 font-semibold">
          {t('order.shipping_information')}
        </h2>
      </div>
      <div className="space-y-3">
        <div>
          <p className="text-xs text-gray-500">{t('order.recipient')}</p>
          <p className="text-sm text-neutral-900 font-medium">
            {shippingLocationName}
          </p>
        </div>
        <div>
          <p className="text-xs text-gray-500">{t('order.delivery_address')}</p>
          <p className="text-sm text-neutral-900">{addressLine1}</p>
          <p className="text-sm text-neutral-900">{addressLine2}</p>
          <p className="text-sm text-neutral-900">
            {city}, {region} {zipCode}
          </p>
        </div>
      </div>
    </div>
  );
}
